import { ref } from 'vue';

/**
 * Toast 消息接口
 */
export interface ToastMessage {
  id: number;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  duration?: number;
}

/**
 * Toast 消息列表
 */
const toasts = ref<ToastMessage[]>([]);

/**
 * Toast ID 计数器
 */
let toastId = 0;

/**
 * 添加 Toast 消息
 * 
 * @param type - 消息类型
 * @param message - 消息内容
 * @param duration - 显示时长（毫秒），0 表示不自动关闭
 */
const addToast = (
  type: 'success' | 'error' | 'warning' | 'info',
  message: string,
  duration = 3000
) => {
  const id = ++toastId;
  toasts.value.push({ id, type, message, duration });
};

/**
 * 移除 Toast 消息
 * 
 * @param id - Toast ID
 */
const removeToast = (id: number) => {
  const index = toasts.value.findIndex(t => t.id === id);
  if (index > -1) {
    toasts.value.splice(index, 1);
  }
};

/**
 * Toast 工具函数
 */
export const useToast = () => {
  return {
    toasts,
    success: (message: string, duration?: number) => addToast('success', message, duration),
    error: (message: string, duration?: number) => addToast('error', message, duration),
    warning: (message: string, duration?: number) => addToast('warning', message, duration),
    info: (message: string, duration?: number) => addToast('info', message, duration),
    remove: removeToast,
  };
};

